import { cx } from '@eti/styles';
import { buttonStyles } from '../styles/style';
import { jsx as _jsx } from "react/jsx-runtime";
const Button = ({
  children,
  className,
  onClick,
  ...rest
}) => /*#__PURE__*/_jsx("button", {
  className: cx(buttonStyles, className),
  onClick: onClick,
  type: "button",
  ...rest,
  children: children
});
export default Button;
//# sourceMappingURL=Button.js.map